import React from "react";
import CommentsLoader from "./CommentsLoader";
import CommentLoader from "./CommentLoader";


import RequireAuth from "../auth/RequireAuth";

/*
  Управление комментариями
  Если передан параметр commentId, то отображает отдельный комментарий
  Если параметр commentId не передан, то отображает список комментариев
*/
export default function CommentListAjaxManager(props) {
  const commentId = props.commentId;

  return <>

  <RequireAuth protected={
    ()=>{
      if (commentId) {
        return <CommentLoader commentId={commentId}/>  
      } else return <CommentsLoader />
    }
  } public={()=><div>Доступ ограничен. Войдите в систему заново</div>} />
  </>
}